import axiosInstance from '../../core/axiosConfig';
export class RestaurantService {
  async createRestaurant(payload: any) {
    await axiosInstance.post('/restaurant/create', payload, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  async updateRestaurant(payload: any) {
    await axiosInstance.patch('/restaurant/update', payload, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  async deleteAgency(id: number) {
    await axiosInstance.delete('/restaurant/delete', { params: { id } });
  }

  async getRestaurants(restaurantId?: number) {
    const response = await axiosInstance.get('/restaurant/get/admin', { params: { restaurantId } });
    return response.data;
  }
}
